module.exports = __webpack_public_path__ + "img/intelligence.df6783e4.svg";